import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { LoginContext } from "./LoginContext";
import ScholarshipService from "../services/ScholarshipService";

/**
 *
 */
export default function Head() {
    const { t, i18n } = useTranslation();
    const user = useContext(LoginContext);
    const isLoggedIn = user && user.authenticated
    const [systemMessages, setSystemMessages] = useState([]);
    
    useEffect(()=>{
        //Javascript-metod i Designsystemet, theme-uu.js.
        window.setScrollToTop()     
    }, []);

    useEffect(()=>{
        if(isLoggedIn) {
            ScholarshipService.getSystemMessages(i18n.resolvedLanguage)
            .then(response => {
                setSystemMessages(response.data)
            })
            .catch(e => {
                console.log(e);
            });
       }
    }, [i18n.resolvedLanguage, isLoggedIn]);
    
    function isHandlaggare() {
        return isLoggedIn && user && user.authorities.some(authority => authority === 'HANDLAGGARE')
    }

    function isGranskare() {
        return isLoggedIn && user && user.authorities.some(authority => authority === 'GRANSKARE')
    }

    return (
        <>
            {isLoggedIn && (systemMessages && systemMessages.length > 0) &&
                systemMessages.map((m, index) => {
                    return (<div key={index} className="is-no-print alert alert-dismissible pt-5 container-fluid  jumbotron jumbotron-warning jumbotron-fluid" role="alert">
                        <div className="d-flex justify-content-center">
                            <div className="jumbotron-text d-flex align-items-start">
                                <div>
                                    <h2 className="jumbotron-alert-header">{ m.title }</h2>
                                    <p>{ m.message }</p>
                                </div>
                                <button className="is-remove-space-small-negative button-text button-icon button-compact icon-clear active" data-bs-dismiss="alert" type="button" aria-label="Close"></button>
                            </div>
                        </div>
                    </div>)
                })
            }
            
            <header className="layout-header layout-header-desktop">
                <div className="skip-links">
                    <a href="#MainContent" tabIndex="1" className="button">{t('head.skip_to_main_content')}</a>
                </div>
                <div className="to-top">
                    <a href="#ToTop" id="ToTop" className="icon-position-center icon-up icon-large disabled">
                        <span className="visually-hidden">Till toppen</span>
                    </a>
                </div>
                <div className="container">
                    <div className="layout-header-local row position-relative">
                        <div className="layout-header-logo">
                            <a href="https://www.uu.se/" className="layout-logo logo-link">
                                <img alt="Uppsala universitet" src="/stipendium/stipac/static/designsystem/7.1/theme-uu/img/uu-logo-red.svg" />
                            </a>
                        </div>
                        <div className="layout-header-name">
                            <a href="/stipendium/stipac/sok" className="layout-header-name-text"> {isLoggedIn ? t('head.title_logged_in') : t('head.title')}</a>
                        </div>

                        {isLoggedIn &&
                            <div className="layout-header-buttons-row is-only-visible-on-desktop-scroll-top">
                                <nav className="mainMenu is-no-print is-only-visible-on-mobile" aria-label="Huvudmeny mobil">
                                    <div className="modal modal-lg" id="huvud-nav" role="dialog">
                                        <div className="modal-dialog nav-modal-dialog" role="document">
                                            <div className="uu-tree-menu-toggle-overlay open overflow-scroll">
                                                <div className="container">
                                                    <div className="justify-content-between align-items-center">
                                                        <div className="d-flex justify-content-start">
                                                            <a href="http://www.uu.se" className="button button-compact button-text button-icon icon-back">Till universitetets startsida</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="uu-tree-menu-toggle-overlay open overflow-scroll">
                                                <div className="uu-tree-menu nav-expandable container">
                                                    <h3 className="mt-3 ms-4">Meny för Stipendier</h3>
                                                    <ul className="nav uu-tree-menu-list p-4 pt-2">
                                                        <li className="nav-item uu-tree-menu-list-item"><a href="/stipendium/stipac/sok" aria-current="page" className="nav-link current">{t('menu.available_scholarships')}</a></li>
                                                        <li className="nav-item uu-tree-menu-list-item"><a href={'/stipendium/stipac/ansokan/ansokning?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.start')}</a></li>
                                                        <li className="nav-item uu-tree-menu-list-item"><a href={'/stipendium/stipac/ansokan/ansokningar?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.applications')}</a></li>
                                                        <li className="nav-item uu-tree-menu-list-item"><a href={'/stipendium/stipac/ansokan/innehav?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.holding_of_scholarships')}</a></li>
                                                        <li className="nav-item uu-tree-menu-list-item"><a href={'/stipendium/stipac/ansokan/bevakning?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.monitoring_of_scholarships')}</a></li>
                                                    </ul>

                                                    {(isGranskare() || isHandlaggare()) &&
                                                        <><h3 className="mt-3 ms-4">Administration</h3><ul className="nav uu-tree-menu-list p-4 pt-2">
                                                            <li className="nav-item uu-tree-menu-list-item">
                                                                {isGranskare() &&
                                                                    <a href={'/stipendium/stipac/granskning?lang=' + i18n.resolvedLanguage} className="nav-link" tabIndex="-1">Granskning</a>}
                                                            </li>
                                                            <li className="nav-item uu-tree-menu-list-item">
                                                                {isHandlaggare() &&
                                                                    <a href={'/stipendium/stipac/handlaggning/kungorelser?lang=' + i18n.resolvedLanguage} className="nav-link" tabIndex="-1">Handläggning</a>}
                                                            </li>
                                                        </ul></>}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                            </div>}
                        <div className="is-no-print layout-header-buttons header-buttons position-relative">
                            <button type="button" className="button button-text button-icon icon-language is-no-print" onClick={() => i18n.changeLanguage(i18n.resolvedLanguage === 'sv' ? 'en' : 'sv')}><span className="visually-hidden-md"> {t('head.change_language')}</span></button>

                            {!isLoggedIn &&
                                <a href={'/stipendium/stipac/login?lang=' + i18n.resolvedLanguage} className="button button-text button-icon icon-login is-no-print"><span className="visually-hidden-md">{t('head.login')}</span></a>}

                            {isLoggedIn &&
                                <button className="button-icon icon-menu icon-white button-text active button-hide-text-in-xs is-only-visible-on-mobile" aria-expanded="false" aria-controls="huvud-nav" data-bs-toggle="modal" data-bs-target="#huvud-nav"><span className="visually-hidden-md">Meny</span></button>}

                            {isLoggedIn &&
                                <div className="function-menu">
                                    <button className="button-text button-icon function-menu-toggle-buttton icon-logged-in collapsed" data-bs-toggle="collapse" data-bs-target="#toggle-header-menu" aria-controls="toggle-header-menu" aria-expanded="false">
                                        <span className="visually-hidden-md">{user.firstname} {user.lastname}</span>
                                    </button>

                                    <nav id="toggle-header-menu" className="function-menu-container collapse" aria-label="Meny">
                                        <ul className="menu-list nav uu-tree-menu-list nav-expandable function-menu-first-level-list pt-2 pb-2">
                                            {isGranskare() &&
                                                <li className="function-menu-first-level-list-item">
                                                    <a href={'/stipendium/stipac/granskning?lang=' + i18n.resolvedLanguage} className="nav-link function-menu-first-level-list-link icon-tune icon-position-right" tabIndex="-1">Granskning</a>
                                                </li>}
                                            {isHandlaggare() &&
                                                <li className="function-menu-first-level-list-item mb-3">
                                                    <a href={'/stipendium/stipac/handlaggning/kungorelser?lang=' + i18n.resolvedLanguage} className="nav-link function-menu-first-level-list-link icon-tune icon-position-right" tabIndex="-1">Handläggning</a>
                                                </li>}
                                            <li className="function-menu-first-level-list-item">
                                                <form action="/stipendium/stipac/logout" method="post">
                                                    <button onClick={() => { sessionStorage.clear() }} className="button button-text button-icon icon-system-logout icon-black function-menu-logout-button" type="submit">{t('head.logout')}</button>
                                                </form>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </header></>
    )
}